/**
 * Patient search for ChartMind admin tooling (server-side via Cloud Function).
 */

import { functions } from './firebase';

const CALLABLE_TIMEOUT_MS = 30_000;

/**
 * @param {string} query
 * @param {number} [limit]
 * @returns {Promise<Array<{ uid: string, displayName: string, email: string | null, phoneNumber: string | null, role: string, photoURL: string | null }>>}
 */
export async function searchPatients(query, limit = 8) {
  const callable = functions.httpsCallable('searchPatients', { timeout: CALLABLE_TIMEOUT_MS });
  const res = await callable({ query, limit });
  const data = res?.data;
  if (!data || !Array.isArray(data.results)) {
    throw new Error('searchPatients: unexpected response');
  }
  return data.results;
}

const patientSearchService = {
  searchPatients,
};

export default patientSearchService;
